import * as types from './types';
import { cloneDeep, get } from 'lodash';

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.USER_SETTINGS_SET_USER_SETTINGS:
      const clonedState = cloneDeep(state);
      const { userName } = payload.store.SecurityState.userInfo;
      const { key, value } = payload.data;

      return {
        ...state,
        [userName]: {
          // Spread this users existing settings if any exist.
          ...get(clonedState, userName, {}),
          // Overwrite or add the settings passed in the payload.
          [key]: value,
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/common/UserSettings/state/reducer.js